import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';

type Props = {
    ariaLabel?: string;
    isBold?: boolean;
    label: string;
    url: string;
};

export const TextTile = ({ ariaLabel, isBold, label, url }: Props) => {
    return (
        <div
            className={`flex items-center justify-center border border-border-secondary p-xs text-center capitalize hover:bg-background-hover [&_a:hover]:text-primary-400 [&_a:hover]:no-underline [&:hover_a]:text-primary-400 [&:hover_a]:no-underline ${isBold ? '[&_a]:font-bold [&_a]:uppercase' : ''}`}
        >
            <SubtleMonochromeLink
                aria-label={ariaLabel ? `${ariaLabel}: ${label}` : `Search Related Category: ${label}`}
                href={url}
                size="sm"
            >
                {label}
            </SubtleMonochromeLink>
        </div>
    );
};
